import axios, { AxiosResponse } from "axios";
import { WebAPI, IFailCallbackParam } from "../constants";
import { getErrorStatus } from "./getErrorStatus";
import AuthService from "../../common/AuthService";

interface ICallbackParams extends IFailCallbackParam {
  /**
   * WebAPIでシミュレータのシミュレーションが成功した場合に呼び出されます
   * @callback success
   * @param {number} status - httpステータス
   */
  success: (status: number) => void;
}

function AxiosDelete(url: string, token?: string) {
  if (token) {
    return axios.delete(url, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
  } else {
    return axios.delete(url);
  }
}

interface IAxiosInternalParams extends ICallbackParams {
  promise: Promise<AxiosResponse>;
}

function AxiosInternal(params: IAxiosInternalParams) {
  params.promise
    .then((res) => {
      params.success(res.status);
    })
    .catch((err) => {
      const { id, status } = getErrorStatus(err);
      params.fail(id, status);
    });
}

export interface IDeleteConfFileParams extends ICallbackParams {
  /**
   * 認証オブジェクト
   */
  authService?: AuthService;
  /**
   * プロジェクトID
   */
  projectid: string;
  /**
   * 設定ファイルの種類
   */
  type: string;
}

/**
 * ユーザ独自の設定ファイルを削除しデフォルトの設定にリセットします
 * @function deleteConfFile
 * @param {IDeleteConfFileParams} params - 設定ファイル削除パラメータ
 */
 export function deleteConfFile(params: IDeleteConfFileParams): void {
  const { authService, projectid, type } = params;
  const url = WebAPI.DELETE_CONFFILE(projectid, type);
  if (authService) {
    authService.getToken({
      success: (token) => {
        AxiosInternal({
          promise: AxiosDelete(url, token),
          success: params.success,
          fail: (id, status) => {
            if (status === 401) {
              deleteConfFileRetry401(authService, url, params);
            } else {
              params.fail(id, status);
            }
          },
        });
      }, 
      fail: (err) => {
        const {id, status } = getErrorStatus(err);
        params.fail(id, status);
      },
    });
  } else {
    AxiosInternal({
      promise: AxiosDelete(url),
      success: params.success,
      fail: params.fail,
    });
  }
}

/**
 * ユーザ独自の設定ファイルを削除しデフォルトの設定にリセットします
 * @function deleteConfFileRetry401
 * @param {AuthService} authService - 認証オブジェクト
 * @param {string} url - リクエストURL
 * @param {ICallbackParams} params - コールバックパラメータ
 */
function deleteConfFileRetry401(
  authService: AuthService, 
  url: string,
  params: ICallbackParams
): void {
  authService.updateToken({
    success: (token) => {
      AxiosInternal({
        promise: AxiosDelete(url, token),
        success: params.success,
        fail: params.fail,
      });
    },
    fail: (err) => {
      const { id, status } = getErrorStatus(err);
      params.fail(id, status);
    },
  });
}